import { ITenant } from '../../../pages/AbmLocalPage/types'
import { axiosInstanceContratos, axiosInstanceMain } from '../../../utils/axiosGlobalUtils'

export const getLocalesRelacionados = async (tenant: ITenant, codLocal: string) =>
  await axiosInstanceMain.get(`/admin/${tenant.path}/locales/${codLocal}/relacionados`)

// Admin Local Contratos
export const getPagos = async (idContrato: number, page: number, pageSize: number) =>
  await axiosInstanceContratos.get(`contratos/${idContrato}/pagos?page=${page}&size=${pageSize}`)

export const getLinks = async (idContrato: number, page: number, pageSize: number) =>
  await axiosInstanceContratos.get(`contratos/${idContrato}/links-de-pago?page=${page}&size=${pageSize}`)

export const deleteLinks = async (codLocal: string) =>
  await axiosInstanceContratos.delete(`/contratos/links/${codLocal}`)

export const crearObservacion = async (tenant: ITenant, idLocal: number, observaciones: string) =>
  await axiosInstanceMain.post(
    `/admin/${tenant.path}/locales/${idLocal}/observaciones`,
    new Blob([observaciones], { type: 'text/plain' }),
    {
      headers: {
        'Content-Type': 'text/plain'
      }
    }
  )

export const getTiposCuenta = async (tenant: ITenant) => await axiosInstanceMain.get(`/admin/${tenant.path}/cuentatipo`)

export const updateScoringManual = async (tenant: ITenant, codLocal: string, scoring: number) =>
  await axiosInstanceMain.put(`admin/${tenant.path}/scoring/${codLocal}?scoring=${scoring}`)

export const enviarNotifPush = async (tenant: ITenant, codLocal: string, data: any) =>
  await axiosInstanceMain.post(`admin/${tenant.path}/locales/${codLocal}/enviar-push-notification`, data)
